
export class Login { 
	
	public userName: string;
	
	public password: string;
	
	public rememberMe: boolean;
	
}


